export class WatchlistStudent implements IWatchlistStudent {
  /** Watchlist Student ID */
  id?: string | undefined;
  /** Created date */
  dateCreated?: string | undefined;
  /** Updated date */
  dateUpdated?: string | undefined;
  /** Created by user ID */
  createdByUserId?: string | undefined;
  /** Updated by user ID */
  updatedByUserId?: string | undefined;
  /** Person/Student ID */
  personId?: string | undefined;
  /** Primary Advisor ID */
  primaryAdvisorId?: string | undefined;
  /** Company ID */
  companyId?: string | undefined;
  /** Degree Pools */
  degreePools?: string[] | undefined;

  constructor(data?: IWatchlistStudent) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(Data?: any) {
    if (Data) {
      this.id = Data["id"];
      this.dateCreated = Data["dateCreated"];
      this.dateUpdated = Data["dateUpdated"];
      this.createdByUserId = Data["createdByUserId"];
      this.updatedByUserId = Data["updatedByUserId"];
      this.personId = Data["personId"];
      this.primaryAdvisorId = Data["primaryAdvisorId"];
      this.companyId = Data["companyId"];
      if (Array.isArray(Data["degreePools"])) {
        this.degreePools = [] as any;
        for (let item of Data["degreePools"])
          this.degreePools!.push(item);
      }
    }
  }

  static fromJS(data: any): WatchlistStudent {
    data = typeof data === 'object' ? data : {};
    let result = new WatchlistStudent();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["dateCreated"] = this.dateCreated;
    data["dateUpdated"] = this.dateUpdated;
    data["createdByUserId"] = this.createdByUserId;
    data["updatedByUserId"] = this.updatedByUserId;
    data["personId"] = this.personId;
    data["primaryAdvisorId"] = this.primaryAdvisorId;
    data["companyId"] = this.companyId;
    if (Array.isArray(this.degreePools)) {
      data["degreePools"] = [];
      for (let item of this.degreePools)
        data["degreePools"].push(item);
    }
    return data;
  }
}

export interface IWatchlistStudent {
  /** Watchlist Student ID */
  id?: string | undefined;
  /** Created date */
  dateCreated?: string | undefined;
  /** Updated date */
  dateUpdated?: string | undefined;
  /** Created by user ID */
  createdByUserId?: string | undefined;
  /** Updated by user ID */
  updatedByUserId?: string | undefined;
  /** Person/Student ID */
  personId?: string | undefined;
  /** Primary Advisor ID */
  primaryAdvisorId?: string | undefined;
  /** Company ID */
  companyId?: string | undefined;
  /** Degree Pools */
  degreePools?: string[] | undefined;
}